import { buildValueMap } from "./utils";

export const AccountCategoryDef = {
    Income: { value: 1, label: "Income" },
    Expenses: { value: 2, label: "Expenses" },
    Assets: { value: 3, label: "Assets" },
    Liability: { value: 4, label: "Liability" },
    Equity: { value: 5, label: "Equity" }
};

export const AccountSourceDef = {
    Manual: { value: 1, label: "Manual" },
    System: { value: 2, label: "System" },
    Bank: { value: 3, label: "Bank" }
};

export const AccountTypeDef = {
    Income: { value: 1, label: "Income", category: 1 },
    OperatingExpense: { value: 2, label: "Operating Expense", category: 2 },
    COGS: { value: 3, label: "Cost of Good Sold", category: 2 },
    PayrollExpense: { value: 4, label: "Payroll Expense", category: 2 },
    CashAndBank: { value: 5, label: "Cash & Bank Account", category: 3 },
    AccountReceivable: { value: 6, label: "Account Receivable", category: 3 },
    Inventory: { value: 7, label: "Inventory", category: 3 },
    OtherCurrentAsset: { value: 8, label: "Other Current Asset", category: 3 },
    LongTermAsset: { value: 9, label: "Long-Term Asset", category: 3 },
    CreditCard: { value: 10, label: "Credit Card", category: 4 },
    AccountPayable: { value: 11, label: "Account Payable", category: 4 },
    PayrollLiability: { value: 12, label: "Payroll Liability", category: 4 },
    OtherCurrentLiability: { value: 13, label: "Other Current Liability", category: 4 },
    LongTermLiability: { value: 14, label: "Long-Term Liability", category: 4 },
    Equity: { value: 15, label: "Equity", category: 5 },
    OtherExpense: { value: 16, label: "Other Expense", category: 2 }
};

export const JournalEntrySourceTypeDef = {
    Vendor: { value: 1, label: "Vendor" },
    Customer: { value: 2, label: "Customer" }
};

export const JournalEntryStatusDef = {
    Completed: { value: 1, label: "Completed" },
    Recurring: { value: 2, label: "Recurring" }
};

export const JournalRecurrenceTypeDef = {
    Monthly: { value: 1, label: "Monthly" },
    Quarterly: { value: 2, label: "Quarterly" },
    Yearly: { value: 3, label: "Yearly" }
};

export const TransactionCategoryDef = {
    InvoicePaymentReceived: { value: 1, label: "Payment Received For An Invoice" },
    TransferFrom: { value: 2, label: "Transfer from Bank, Credit Card, Loan or Equity" },
    BillRefundReceived: { value: 3, label: "Refund Received for a Bill" },
    ExpenseRefundReceived: { value: 4, label: "Refund Received for Expense" },
    IncomeAccount: { value: 5, label: "Income Accounts" },
    BillPaymentSent: { value: 6, label: "Payment Sent for a Bill" },
    TransferTo: { value: 7, label: "Transfer to Bank, Credit Card or Loan" },
    PaymentToShareholder: { value: 8, label: "Payment to Shareholders" },
    InvoiceRefundSent: { value: 9, label: "Refund Sent for an Invoice" },
    IncomeRefundSent: { value: 10, label: "Refund Sent for Income" },
    ExpenseAccount: { value: 11, label: "Expense Accounts List" }
};

export const TransactionTypeDef = {
    Deposit: { value: 1, label: "Deposit" },
    Withdrawal: { value: 2, label: "Withdrawal" }
};

export const AccountCategory = buildValueMap(AccountCategoryDef);
export const AccountSource = buildValueMap(AccountSourceDef);
export const AccountType = buildValueMap(AccountTypeDef);
export const JournalEntrySourceType = buildValueMap(JournalEntrySourceTypeDef);
export const JournalEntryStatus = buildValueMap(JournalEntryStatusDef);
export const JournalRecurrenceType = buildValueMap(JournalRecurrenceTypeDef);
export const TransactionCategory = buildValueMap(TransactionCategoryDef);
export const TransactionType = buildValueMap(TransactionTypeDef);
